//css-------------------
import '../../css/share/common.scss';
import '../../css/home/welcome.scss';

//fontawesome
import( /* webpackPrefetch: true */ '../../lib/fontawesome/fontawesome.scss');
import( /* webpackPrefetch: true */ '../../lib/fontawesome/regular.scss');
import( /* webpackPrefetch: true */ '../../lib/fontawesome/brands.scss');

//js----------------------
//components
import( /* webpackPrefetch: true */ '../share/components/_common');
import( /* webpackPrefetch: true */ '../share/components/_header');
import( /* webpackPrefetch: true */ '../share/components/_lightbox');
import( /* webpackPrefetch: true */ '../share/components/_welcome_parallax');
import( /* webpackPrefetch: true */ '../share/components/_welcome_canvas_fog');
import( /* webpackPrefetch: true */ '../share/components/_welcome_scrolltrigger');
// import( /* webpackPrefetch: true */ '../share/components/_click_effect');
import( /* webpackPrefetch: true */ '../share/components/_welcome_lazy');
import( /* webpackPrefetch: true */ '../share/components/_cookie');
import( /* webpackPrefetch: true */ '../share/components/_content_scrolltrigger');

//npm lib
import $ from "jquery";
import { gsap } from "gsap";
import imagesLoaded from "imagesloaded";
import { createApp } from 'vue/dist/vue.esm-browser.prod.js';
import { Loader } from "@googlemaps/js-api-loader"

$(function () {
    const app = createApp({
        data() {
            return {

            }
        },
        mounted() {
            const _this = this;
            imagesLoaded("html, body", function () {
                $(".loading").fadeOut(function () {

                    _this.hash_to();
                    _this.initMap();

                    $(this).remove();

                    $('head').append('<link rel="preconnect" href="https://fonts.googleapis.com">')
                    $('head').append('<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>')
                    $('head').append('<link href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300..800&family=Oswald:wght@200..700&display=swap" rel="stylesheet">')

                });
            });
        },
        methods: {
            async initMap() {
                const loader = new Loader({
                    apiKey: "AIzaSyBULqEI8fDJ1L2b6OpJcA6KAM__ZX0mTg8",
                    version: "weekly",
                });

                loader.load().then(async () => {
                    const googleMap = $('#googleMap');
                    const { Map } = await google.maps.importLibrary("maps");
                    const center = {
                        lat: googleMap.data('lat'),
                        lng: googleMap.data('lng'),
                    };
                    const styles = [{ "featureType": "water", "stylers": [{ "visibility": "on" }, { "color": "#b5cbe4" }] }, { "featureType": "landscape", "stylers": [{ "color": "#efefef" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#83a5b0" }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#bdcdd3" }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e3eed3" }] }, { "featureType": "administrative", "stylers": [{ "visibility": "on" }, { "lightness": 33 }] }, { "featureType": "road" }, { "featureType": "poi.park", "elementType": "labels", "stylers": [{ "visibility": "on" }, { "lightness": 20 }] }, {}, { "featureType": "road", "stylers": [{ "lightness": 20 }] }];

                    const map = new Map(document.getElementById("googleMap"), {
                        center,
                        zoom: 11,
                        styles: styles,
                    });
                });
            },
            hash_to() {
                var hash = location.hash.substr(1);
                if (hash) {
                    hash = hash.replace('anchor_', '');
                    var _scrollTop = $('#' + hash).offset().top - $(window).height() / 3;
                    gsap.to('html, body', { duration: 1.5, scrollTop: _scrollTop, ease: 'quart.out' });
                }
            },
        },
    }).mount('#app');


});